import client from '@stores/apollo'
import gql from 'graphql-tag'
import { INeighborhoodImport } from '@api/types'
import { NeighborhoodImportFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  viewer: {
    company: {
      employeesNeighborhoodsImports: {
        edges: Array<{ node: INeighborhoodImport }>
      }
    }
  }
}

const mutateHandler = handleFetchResult<IPayload, INeighborhoodImport | undefined>({
  handler: ({
    viewer: {
      company: {
        employeesNeighborhoodsImports: { edges },
      },
    },
  }) => {
    return edges.find(({ node: { status } }) => status === 'pending' || status === 'queued')?.node
  },
  name: 'Neighborhood Connection',
})

export default function isActive(): Promise<INeighborhoodImport | undefined> {
  return client.gql.query({ query }).then(mutateHandler)
}

const query = gql`
  query isActive {
    viewer {
      company {
        employeesNeighborhoodsImports(first: 1) {
          edges {
            node {
              ...NeighborhoodImportFragment
            }
          }
        }
      }
    }
  }
  ${NeighborhoodImportFragment}
`
